import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { ArrowRight } from "@bw/icons"
import * as css from "./TeaserList.module.css"

const TeaserList = ({ to, href, isExternal, suptitle, title, subtitle }) => {
  const item = (
    <>
      <div className={`${css.body} teaser-list__body`}>
        {suptitle && (
          <div className={`${css.suptitle} teaser-list__subtitle`}>
            {suptitle}
          </div>
        )}
        <div className={`${css.title} teaser-list__title`}>{title}</div>
        {subtitle && (
          <div className={`${css.subtitle} teaser-list__subtitle`}>
            {subtitle}
          </div>
        )}
      </div>
      <div className={`${css.arrow} teaser-list__arrow`}>
        <ArrowRight />
      </div>
    </>
  )

  const target = isExternal ? "_blank" : null

  return to ? (
    <Link to={to} target={target} className={`${css.wrapper} teaser-list`}>
      {item}
    </Link>
  ) : (
    <a href={href} target={target} className={`${css.wrapper} teaser-list`}>
      {item}
    </a>
  )
}

TeaserList.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  title: PropTypes.string.isRequired,
  suptitle: PropTypes.string,
  subtitle: PropTypes.string,
}

export { TeaserList }
